// Turbo frame rendering that WebKit's garbage collector cannot break.
//
// Turbo renders a frame response by moving the new frame's children out with
// Range#extractContents() and appending the fragment it returns. The nested
// <turbo-frame> elements among those children were already constructed (when
// Turbo imported the response), and Turbo keeps their state on the element's JS
// wrapper: `this.delegate`, set in the constructor. In WebKit (every iOS browser
// and macOS Safari) that fragment has no JS wrapper until the call returns, and
// creating it can trigger a collection; at that moment nothing reaches the moved
// subtree, so the nested frame's wrapper is collected and its delegate with it.
// WebKit then runs connectedCallback on a fresh wrapper and throws
// "undefined is not an object (evaluating 'this.delegate.connect')", the nested
// frame never loads, and the next render throws the same for disconnect.
//
// That was Sentry SKILLOUT-PRODUCTION-R1/R2/RM/TF/TG: ~240 events a month, all
// WebKit, all on test_practice, whose frame nests the question-image-preloads
// frame (and report_mistake_form once a question is answered). Reproduced in
// WebKitGTK with JSC_slowPathAllocsBetweenGCs; it stopped once the fragment was
// created here, before any node moves into it.
//
// So the stock frame render is swapped (through Turbo's documented render hook)
// for the same render done through a fragment this code holds: the moved
// subtree is reachable the whole time. Morph and other custom renders are left
// alone.
//
// Old engines without replaceChildren (Chromium < 86, e.g. LG NetCast TVs:
// SKILLOUT-PRODUCTION-TT) get the old children removed one by one instead.
import { FrameRenderer } from "@hotwired/turbo"

export function renderFrameContents(currentElement, newElement) {
  const fragment = document.createDocumentFragment()
  while (newElement.firstChild) fragment.appendChild(newElement.firstChild)
  if (typeof currentElement.replaceChildren === "function") {
    currentElement.replaceChildren(fragment)
  } else {
    while (currentElement.firstChild) currentElement.removeChild(currentElement.firstChild)
    currentElement.appendChild(fragment)
  }
}

document.addEventListener("turbo:before-frame-render", (event) => {
  if (event.detail.render === FrameRenderer.renderElement) event.detail.render = renderFrameContents
})
